<div class="mainInfo">
  <h1>{{ title }}</h1>
  <p>Para continuar, necesitamos que abras la app de Krediya que ha sido instalada, para que puedas reportar tus pagos.</p>
</div>

<div class="msgBlock pt-30">
  <div class="msgBlock__wrapper">
    <div class="msgBlock__content">
      <div class="top bigBottomPad">
        <app-sales-credit-codes-shared
          [contractNumber]="contractNumber"
          [personNumber]="personNumber">
        </app-sales-credit-codes-shared>
      </div>
    </div>
  </div>
</div>

<footer class="pt-30">
  <div class="footer__content">
    <app-phone-app-footer-button-shared [state]="appState" (continueClick)="onContinue()"></app-phone-app-footer-button-shared>
  </div>
</footer>

<app-phone-app-confirmation-modal-shared [visible]="visibleModal" (continueClick)="onContinue()"></app-phone-app-confirmation-modal-shared>
